import "./CookieNotice.scss";

export const CookieNotice = (props: {
  onOK: () => void;
  onCancel: () => void;
}): JSX.Element => {
  const onOK = () => {
    props.onOK();
  };

  const onCancel = () => {
    props.onCancel();
  };

  return (
    <div className="cookieNotice">
      <p>This website uses cookies to ensure you get the best experience on our website.</p>
      <div className="buttons">
        <button className="ok button" onClick={onOK} aria-label="Got it!">Got it!</button>
        <button className="cancel button" onClick={onCancel} aria-label="decline cookies policy">Decline</button>
      </div>
    </div>
  );
};
